import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import DisplayList from './components/DisplayList.vue';
import Details from './components/Details.vue';
import RemoveVotes from './components/RemoveVotes.vue';
import Category from './components/Category.vue';

import store from "./store";
import BootstrapVue from "bootstrap-vue";
import ToggleButton from 'vue-js-toggle-button';
import VueAnalytics from 'vue-analytics'

// More Bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(ToggleButton);

const routes = [
  { path: '/', name: 'home', component: DisplayList },
  { path: '/details/:id', name: 'details', component: Details},
  { path: '/myvotes', name: 'myvotes', component: RemoveVotes},
  { path: '/categories', name: 'categories', component: Category}
]

const router = new VueRouter({
  routes // short for `routes: routes`
})

Vue.use(VueAnalytics, {
  id: 'UA-23365538-2',
  router
})


Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
